__turbopack_context__.v({
  "_cross": "mobile-select-module-scss-module__HsIUuW___cross",
  "_handle": "mobile-select-module-scss-module__HsIUuW___handle",
  "_highlight": "mobile-select-module-scss-module__HsIUuW___highlight",
  "_outlined": "mobile-select-module-scss-module__HsIUuW___outlined",
  "_withCross": "mobile-select-module-scss-module__HsIUuW___withCross",
  "checkbox": "mobile-select-module-scss-module__HsIUuW__checkbox",
  "closeControl": "mobile-select-module-scss-module__HsIUuW__closeControl",
  "content": "mobile-select-module-scss-module__HsIUuW__content",
  "drawer": "mobile-select-module-scss-module__HsIUuW__drawer",
  "drawerContent": "mobile-select-module-scss-module__HsIUuW__drawerContent",
  "drawerTopPanel": "mobile-select-module-scss-module__HsIUuW__drawerTopPanel",
  "list": "mobile-select-module-scss-module__HsIUuW__list",
  "option": "mobile-select-module-scss-module__HsIUuW__option",
  "option_selected": "mobile-select-module-scss-module__HsIUuW__option_selected",
  "radio": "mobile-select-module-scss-module__HsIUuW__radio",
  "title": "mobile-select-module-scss-module__HsIUuW__title",
  "trigger": "mobile-select-module-scss-module__HsIUuW__trigger",
  "trigger__label": "mobile-select-module-scss-module__HsIUuW__trigger__label",
});
